module.exports = __webpack_public_path__ + "static/media/myImage.bd80794f.png";